import { createFileRoute } from '@tanstack/react-router';
import { TenantSettingsPanel } from '../../../features/settings/components/TenantSettingsPanel';

/** Default Settings tab (BUILD_SPEC.md §5.1, §11) — over-receipt tolerance %,
 * invoice footer, other per-tenant defaults. Plan.md G26. */
export const Route = createFileRoute('/_authenticated/settings/')({
  component: TenantSettingsPanel,
});
